import $ from 'jquery'
export default {
    name: "autre-prestation",
    components: {},
    props: {
        user_id: Number,
        info_patient: Object,
        info_caissier: Object,
        is_proforma: Boolean,
        proforma_id: Number,
        can_add_differential_computing: Object,
        format_ref_facture: String,
        info_patient_assure: Object
    },
    data() {
        return {
            save_loading: false,
            prestation: {
                parent_id: 0,
                data_type: 'autre_prestation',
                uid: '',
                libelle: "",
                prix_clinique: "",
                prix_base_calcul: "",
                prix_assure_clinique: "",
                taux_couverture: "",
                qte: 1,
                est_exclu: 0,
            },
            err_msg: "",

            is_error: false,
            permission_is_denied: false,
        };
    },

    computed: {},

    mounted() { },

    methods: {
        async onlyDigit(selector) {
            $("#" + selector).val(
                $("#" + selector)
                    .val()
                    .replace(/[^0-9]+/g, "")
            );
        },

        clearError() {
            this.err_msg = ""
        },

        formValidator() {
            const prix_clinique = this.cleanNumber(this.prestation.prix_clinique)
            const base_assurance = this.cleanNumber(this.prestation.prix_base_calcul)
            const pac = this.cleanNumber(this.prestation.prix_assure_clinique)
            const taux = this.cleanNumber(this.prestation.taux_couverture)
            const qte = this.cleanNumber(this.prestation.qte)
            

            if (typeof prix_clinique == 'string') {
                this.err_msg = "Le prix unitaire doit être un nombre"
                return;
            }
            
            if (this.info_patient_assure.est_assure == 1) {
                if (typeof base_assurance == 'string') {
                    this.err_msg = "La base assurance doit être un nombre"
                    return;
                }

                if (this.can_set_pac && typeof pac == 'string') {
                    this.err_msg = "Le prix assuré doit être un nombre"
                    return;
                }            

                if (typeof taux == 'string') {
                    this.err_msg = "Le taux assurance doit être un nombre"
                    return;
                }

                if (taux < 0 || taux > 100) {
                    this.err_msg = "Le taux assurance doit être compris entre 0 et 100"
                    return;
                }
            }

            this.prestation.prix_clinique = prix_clinique
            this.prestation.prix_base_calcul = base_assurance
            this.prestation.prix_assure_clinique = pac
            this.prestation.taux_couverture = taux
            this.prestation.qte = qte
        },

        async submit() {
            const isValid = await this.$refs.other_form.validate();
            if (!isValid) {
                return;
            }

            this.formValidator()
            if (this.err_msg != "") {
                return;
            }

            // GEnerate uid
            this.prestation.uid = this.setSinglePrestationUID(this.prestation.libelle)

            let pac = 0
            if (this.can_set_pac) {
                pac = this.prestation.prix_assure_clinique
            } else {
                pac = this.prestation.prix_clinique
            }

            // Calcul du prix additionnel
            let prix_additionnel = 0
            if (this.prestation.prix_base_calcul > 0) {
                prix_additionnel = (pac > this.prestation.prix_base_calcul)?(pac - this.prestation.prix_base_calcul):0
            } else {
                prix_additionnel = pac
            }
            this.prestation.prix_additionnel = prix_additionnel

            let data = {
                user_id: this.user_id,
                patient_id: this.info_patient.id,
                prestations: [this.prestation],
                type_prestation: 'Autres',
                data_type: 'autre_prestation',
                proforma_id: this.proforma_id,
                is_proforma: this.is_proforma,
                can_add_differential_computing: this.can_add_differential_computing.response,
                can_set_pac: this.can_set_pac,
                info_caissier: this.info_caissier,
                info_patient: {
                    nom_patient: this.info_patient.nom,
                    sexe: this.formatSexeMetier(this.info_patient.sexe),
                    telephone: this.info_patient.telephone_mobile,
                    num_dossier: this.info_patient.num_dossier,
                    age: this.info_patient.age
                },
                format_ref_facture: this.format_ref_facture,
                is_vente_caisse: 1,
                est_assure: (this.info_patient_assure.est_assure)?this.info_patient_assure.est_assure:0
            }

            this.save_loading = true
            this.$store.dispatch('saveAutrePrestationProforma', data).then((response) => {
                if (response.success) {
                    this.successToast('Ajout effectué avec succès')

                    this.$emit('emitPrestation', response.fpro_id)

                    this.$refs.fpro_other.click()

                    this.prestation = {
                        parent_id: 0,
                        data_type: 'autre_prestation',
                        uid: '',
                        libelle: "",
                        prix_clinique: "",
                        prix_base_calcul: "",
                        prix_assure_clinique: "",
                        taux_couverture: "",
                        qte: 1,
                        est_exclu: 0,
                    }

                    if (response.fpro_id > 0) {
                        this.$router.push({ path: '/ventes/facture-proforma/'+response.fpro_id })
                    }
                } else {
                    if (response.code === 500) {
                        this.is_error = true
                    } else if (response === 403) {
                        this.permission_is_denied = true
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
            })
        }
    },
};


